export interface PieInterface {
    contenidoPrimario:string;
    contenidoSecundario:string;
    colorTexto:string;
    colorPrimario:string;
    colorSecundario:string;
}

export class Pie {
    constructor(
        public contenidoPrimario:string,
        public contenidoSecundario:string,
        public colorTexto:string,
        public colorPrimario:string,
        public colorSecundario:string
    ) {       
    }
}

export class PieMaker {
    static createInterface(event:PieInterface):PieInterface {
        return { contenidoPrimario: event.contenidoPrimario, contenidoSecundario: event.contenidoSecundario,
        colorTexto: event.colorTexto, colorPrimario: event.colorPrimario, colorSecundario: event.colorSecundario }
    }

    static create(event: Pie):Pie {
        return new Pie(event.contenidoPrimario, event.contenidoSecundario,
            event.colorTexto, event.colorPrimario, event.colorSecundario);
    }
}